import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, getFormValues } from 'redux-form';

import { connect } from 'react-redux';

import Uppy from "./uielements/uppy";
import "./uielements/uppy.css"
// import config from "./config";
import agent from '../agent'
//import parse from 'html-react-parser';

const config = {
  target: '#uppyHolder',
  inline: true,
  fieldName: 'medium[asset]',
  autoProceed: false,
  restrictions: {
    maxFileSize: 10000000 * 100, //1GB
    maxNumberOfFiles: 25,
    // minNumberOfFiles: 2,
    allowedFileTypes: ['.jpeg', '.jpg', '.png', '.gif', 'audio/*', '.pdf', '.doc', '.docx', '.mp4', 
                       '.mov', '.m4v', '.mp3', '.aiff', '.aif', '.aac', '.m4a', '.m4p', '.mpc', '.ogg', 
                       '.wav', '.wma', '.webm', '.flv', '.avi', '.wmv', '.mpeg', '.mpg', '.heiv', '.mkv',
                       '.webm'],

  },
  proudlyDisplayPoweredByUppy: false,
  metaFields: [
    { id: 'name', name: 'Name', placeholder: 'file name' },
    { id: 'caption', name: 'Caption', placeholder: 'describe what the image is about' },
    { id: 'medium[audition_ids]', name: 'Audition Id', placeholder: 'Audition ID' },
    { id: 'medium[project_id]', name: 'Project Id', placeholder: 'Project ID' }
  ],
  
  xhrUpload: {
    // endpoint: `'${agent.API_ROOT}/checkin/media`,
    // headers: {
    //   // 'authorization': `Token token="gBXHsKTyYtJ4LDhRbRyA", email="admin@am.com"`
    //   'authorization': `Token token="${agent.authToken.token || agent.authToken.authentication_token}", email="${agent.authToken.email}"`
    // },
    fieldName: 'medium[asset]',
    metaFields:['medium[audition_ids]', 'medium[project_id]', 'medium[uploader_id]'],
    limit: 1,
    timeout: 600 * 1000 // 600sec
  }
};


class Media extends Component {
  constructor(props) {
    super(props);
    this.fileAdded = this.fileAdded.bind(this);
  }
  state = {
    enableNextButton: !this.props.project.public_upload || !this.props.project.public_artist_upload_required,
    // project_id: this.props.auditions[0].project_id,
    // auditions_ids: this.props.auditions.map(audition => audition.id),
    // artist_id: this.props.auditions[0].artist_id
    toogleSupportedMedia: false
  }
  componentWillMount() {
    const { artistValues } = this.props
    console.log('componentWillMount-media', artistValues)
    this.setState({
      project_id: artistValues.project_id,
      auditions_ids: artistValues.audition_ids,
      artist_id: artistValues.artist_id
    })
  }
  componentDidMount() {
    const { authentication_token, email } = JSON.parse(window.localStorage.getItem('user_jwt'))
    const params  = {
      filename: '',
      content_type: '',
      file_size: ''
    }
    
    let auditions_ids = this.state.auditions_ids
    let project_id = this.state.project_id
    
    config.auditions_ids = auditions_ids
    config.project_id = project_id

    config.xhrUpload.endpoint = `${agent.API_ROOT}/checkin/media`//agent.Project.requestSignedURL(this.state.auditions_ids, params); //`${agent.API_ROOT}/checkin/media`
    config.xhrUpload.headers = {
      'authorization': `Token token="${authentication_token}", email="${email}"`
    }

    this.uppy = Uppy(config);

    // Before initializing the listeners, try to add the 
    // files under the audition

    let uppy = this.uppy;
    uppy.cancelAll()

    this.setState({ enableNextButton: (this.props.filesList.length > 0) });

    this.props.filesList.forEach(function(media) {
      fetch(media.thumbnail).then((response) => response.blob()).then((blob) => {
        let fid = uppy.addFile({
          name: media.filename,
          type: media.content_type,
          data: blob,
          meta: { on_server: true },
          remote: true
        });

        uppy.setFileState(fid, { 
          progress: { uploadComplete: true, uploadStarted: new Date(), percentage: 100, bytesTotal: media.file_size, bytesUploaded: media.file_size } 
        })
      });
    });

    this.uppy.on('file-added', this.fileAdded)

    this.uppy.on('upload-success', this.onSuccess)
    this.uppy.on('complete', (result) => this.onComplete(result))

  }

  fileAdded (file) {
    console.log("fileadded: ", file)
    let audition_ids = this.state.auditions_ids
    let project_id = this.state.project_id
    let artist_id = this.state.artist_id

    this.uppy.setFileMeta(file.id, {
      "medium[audition_ids]": audition_ids,
      "medium[project_id]": project_id,
      "medium[uploader_id]": artist_id,

    })
  }

  nl2br (str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  }

  onComplete = (result) => {
    console.log('successful files:', result.successful)
    console.log('failed files:', result.failed)

    //let artist_id = this.state.artist_id
    let audition_ids = this.state.auditions_ids
    //agent.Artist.finalizeFiles(artist_id).then(({result}) => { this.setState({enableNextButton: true}) } )
    // audition_ids.forEach(function(aud_id) {
    //   agent.Artist.finalizeFiles(aud_id)
    // })
    this.setState({enableNextButton: true})
  }

  onSuccess(file, resp) {
    // console.log('onSuccess', file, resp, uploadURL)
    // Parse the upload URL
    let url = new URL(resp.uploadURL);
    let pieces = url.pathname.split('/');
    let mediumID = pieces[pieces.length - 2];

    agent.Artist.finalizeFiles(mediumID);
  }

  onSupportedMedia() {
    if (this.state.toogleSupportedMedia) {
      this.setState({
        toogleSupportedMedia: false
      })
    } else {
      this.setState({
        toogleSupportedMedia: true
      })
    } 
  }

  render() {
    const { handleSubmit, previousPage, nextPage, pristine, submitting, media, publicArtist } = this. props
    const { enableNextButton } = this.state
    const padding0 = {
      padding: '0'
    }
    return (
      <form onSubmit={handleSubmit} className="checking-availability-form">

        <section className="section gray-bg public-registration">
          <div className="grid-x align-center">
          <div className="small-12 medium-10 large-8 cell">


            <div className="row small-12 media-wrapper">
              <div className="column medium-9 upload-media">
                <div className="row medium-8 align-left text-left">
                  <h5>Upload ALL Required Media Files for this Project</h5>
                  {
                    this.props.project.public_artist_upload_required ?
                      <p>You are required to upload Audition Media for this job:</p> : <p></p>
                  }
                  <p className="upload-supported-media align-left">Please see a list of <a className="supported-media" onClick={e => this.onSupportedMedia()}>supported media files</a> you can upload</p>
                  {
                    this.state.toogleSupportedMedia ?
                      <div className="toogle-support row small-12">
                        <div className="column"><b>Image:</b> png, jpg, jpeg, bmp, gif</div>
                        <div className="column"><b>Audio:</b> mp3, aac, m4a, wav, wma</div>
                        <div className="column"><b>Video:</b> flv, avi, wmv, mov, mp4, mpg, mpeg, m4v, heiv, mkv, webm, m4v+gif</div>
                        <div className="column"><b>Document:</b> pdf, doc, docx</div>
                      </div> : <div></div>
                  }
                  {
                    this.props.project.video_instruction && this.props.project.video_instruction.length &&
                      <p><strong>Upload instructions:</strong> <div dangerouslySetInnerHTML={{ __html: this.nl2br(this.props.project.video_instruction) }} /></p>
                  }
                </div>
              </div>
              <div className="column medium-3 taped-media">
                <div className="grid-x">
                  <div style={padding0} className="cell medium-12 small-6">
                    <p>Need help with your self tape media? <a href="https://www.auditionmagic.com/selftaping/" target="_blank"><b>click here</b></a></p>
                  </div>
                  <div style={padding0} className="cell medium-12 small-6">
                    <p>Download handbreak to reduce file size: <a href="https://handbrake.fr/downloads.php" target="_blank"><b>click here</b></a></p>
                  </div>
                  <div style={padding0} className="cell medium-12 small-6">
                    <p>To convert HEIC / HEIF to JPG or supported formats: <a href="https://www.howtogeek.com/666363/how-to-convert-heic-photos-to-jpg-on-iphone-and-ipad/" target="_blank"><b>follow instructions mentioned here.</b></a></p>
                  </div>
                </div>
              </div>
            </div>

            <div className="uppy-adjustments" id="uppyHolder"></div>
            <div className="text-center" id="pubreg-media-upload-btn"></div>

          </div>
          </div>
        </section>

        <section className="section">
          <div className="grid-x align-center">
            <div className="small-12 cell text-center">
              {
                previousPage &&
                <button 
                  className="button primary previous" 
                  type="button" 
                  onClick={previousPage} >Previous</button>
              }

              {
                nextPage 
                ? <button className="button primary next" type="submit" disabled={!enableNextButton || pristine || submitting}>Next</button>
                : <button className="button primary" 
                    type="submit" 
                    disabled={pristine || submitting}>
                      {submitting ? 'Submitting you checking...' : 'Submit' }
                  </button>
              }
            </div>
          </div>
        </section>
      </form>
    )
  }
}

Media = reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(Media)


const mapStateToProps = state => ({
  artistValues: getFormValues('checkinWizard')(state)
});

const mapDispatchToProps = dispatch => ({});


export default connect(mapStateToProps, mapDispatchToProps)(Media)


// WEBPACK FOOTER //
// ./src/components/Media.js